import { IOption } from '../../interfaces/FormFields'

export const LOGEMENT: IOption[] = [
  { value: '', label: 'Choisir une option...' },
  {
    value: '1',
    label: 'Je suis propriétaire, locataire ou accédant à la propriété',
  },
  { value: '2', label: 'Je suis hébergé par une personne physique' },
]

export const SELECT_FIRST_OPTION = { value: '', label: 'Sélectionner' }
